import { makeAutoObservable } from "mobx"

export default class WaitlistStatus {
  id?: number
  onWaitlist: boolean
  onWaitlistSince?: Date
  participationId?: number
  sticky: boolean

  constructor(props: any) {
    makeAutoObservable(this, {}, { autoBind: true })

    this.id = props.id
    this.onWaitlist = props.onWaitlist
    this.onWaitlistSince = props.onWaitlistSince
    this.participationId = props.participationId
    this.sticky = props.sticky
  }
}
